import {
  getImageBase64,
  getBackground,
  getThemePic,
} from "@/views/home/slidePPT/use/methods";
import { pathToBase64 } from "@/utils";

export default async function (data) {
  const node = data.node;
  const catalogueList = node.list || node.children;
  const color = data.color;
  let htmlText = "<ul>";
  for (let i = 0; i < catalogueList.length; i++) {
    const item = catalogueList[i];
    htmlText += `<li style=\"text-align: left;\"><span style=\"font-size: 24.49px;font-family: Microsoft Yahei;\">${item}</span></li>`;
  }
  htmlText += "</ul>";
  const id = Math.random().toString(36).slice(-8);
  const background = await getBackground(data?.customTheme, "theme");
  const ex1 = await getThemePic(data?.customTheme, "ex-1");
  const ex2 = await getThemePic(data?.customTheme, "ex-2");
  const ex3 = await getThemePic(data?.customTheme, "ex-3");
  const ex4 = await getThemePic(data?.customTheme, "ex-4");

  return {
    id: id,
    elements: [
      {
        type: "image",
        id: "tDeBOiFzMh",
        src: ex1,
        width: 1000,
        height: 468.6,
        left: 0,
        top: 305.29,
        fixedRatio: true,
        rotate: 0,
        flipH: false,
        flipV: false,
      },
      {
        type: "image",
        id: "nM6bj6XkZE",
        src: ex2,
        width: 108.57,
        height: 83.31,
        left: 853.26,
        top: 42.3,
        fixedRatio: true,
        rotate: 0,
        flipH: false,
        flipV: false,
      },
      {
        type: "text",
        id: "vdwbVsiP_h",
        width: 153.46,
        height: 76.09375,
        left: 761.37,
        top: 190.11,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "rgba(157,155,155,1)",
        content:
          '<p style="text-align: justify;"><span style="font-size: 55.1px;font-family: Times New Roman;font-weight: bold;">目录</span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "66k_a8nvWU",
        width: 191.40999999999997,
        height: 49.5625,
        left: 770.42,
        top: 263.12,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "rgba(157,155,155,1)",
        content:
          '<p style="text-align: justify;"><span style="font-size: 28.57px;font-family: Times New Roman;">CATALOG</span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "text",
        id: "KBNjnqZHyj",
        width: 37.21,
        height: 60,
        left: 25.08,
        top: 0,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "rgba(157,155,155,1)",
        content:
          '<p style="text-align: left;"><span style="font-size: 1.02px;font-family: 微软雅黑;">PPT</span><span style="font-size: 1.02px;font-family: 微软雅黑;">下载</span><span style="font-size: 1.02px;font-family: 微软雅黑;">http://www.1ppt.com/xiazai/</span></p>',
        lineHeight: 1,
        outline: {
          color: "#000",
          width: 0,
          style: "solid",
        },
        fill: "",
        vertical: false,
      },
      {
        type: "image",
        id: "39IqoWgIWU",
        src: ex3,
        width: 223.57,
        height: 79.49,
        left: 776.43,
        top: 90.9,
        fixedRatio: true,
        rotate: 0,
        flipH: true,
        flipV: false,
      },
      {
        type: "image",
        id: "IhVrCXHlAY",
        src: ex4,
        width: 120.32,
        height: 120.32,
        left: 848.8,
        top: 62.93,
        fixedRatio: true,
        rotate: 0,
        flipH: false,
        flipV: false,
      },
      {
        type: "text",
        id: "FKQsx5EgLg",
        left: 123.4541792547834,
        top: 137.23308734055047,
        width: 361.664988251091,
        height: 241.921875,
        content: htmlText,
        rotate: 0,
        defaultFontName: "Microsoft Yahei",
        defaultColor: "#9D9B9B",
        vertical: false,
      },
    ],
    background,
  };
}
